import * as THREE from "three";

// 精简的核心配置接口 (9个参数)
export interface TextToPointCloudConfig {
  // 文本基础参数 (4个)
  text: string;
  fontFamily: string;
  fontSize: number;
  fontWeight: string;

  // Canvas尺寸参数 (2个) - 用于点云尺寸矫正
  canvasWidth: number;
  canvasHeight: number;

  // 点云核心参数 (3个)
  pointDensity: number;
  pointSize: number;
  depthScale: number;
}

// 合并相关状态为单一对象
export interface PointCloudState {
  geometry: THREE.BufferGeometry | null;
  count: number;
  canvasDataUrl: string | null;
}

export interface GenerationState {
  isGenerating: boolean;
  progress: number;
  error: string | null;
}

export interface TextRenderResult {
  pointCloud: PointCloudState;
  generation: GenerationState;
}

// 内部处理类型
export interface TextDimensions {
  width: number;
  height: number;
  coverageX: number; // 文本在Canvas中的X轴覆盖率 (0-1)
  coverageY: number; // 文本在Canvas中的Y轴覆盖率 (0-1)
}

export interface WorldCoordinates {
  worldX: number;
  worldY: number;
  targetWidth: number;
  targetHeight: number;
}

export interface CrystalDimensions {
  width: number;
  height: number;
  depth: number;
  maxDimension: number;
  scaleRatio: number;
}

// 默认配置 (精简版)
export const DEFAULT_CONFIG: TextToPointCloudConfig = {
  text: "",
  fontFamily: "Arial",
  fontSize: 48,
  fontWeight: "bold",
  canvasWidth: 400,
  canvasHeight: 200,
  pointDensity: 12, // 极高密度创造更丰富的白雪效果
  pointSize: 0.004, // 极小点尺寸，超精细雕刻效果
  depthScale: 0.2,
};